<div class="main-section">
  <div class="main-section-content">
    <ng-template #printLabelModal let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h6 class="modal-title"><i class="fas fa-print"></i> Print Label</h6>
        <button
          type="button"
          class="btn btn-close"
          aria-label="Close"
          (click)="closePrintLabelModal(true)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body email-scrollbar">
        <div class="mainPopupModual">
          <div class="col-xl-12 col-lg-12 spacing">
            <form [formGroup]="printLabelForm">
              <div class="form-group">
                <div class="col-12 d-flex justify-content-center">
                  <div class="col-4">
                    <label for="CustomerMailId" name="title" class="form-label"
                      ><b>Price Level</b> <span class="stariCON">*</span></label
                    >
                  </div>
                  <div class="col-10">
                    <mat-select
                      [dir]="langDir"
                      class="form-control"
                      formControlName="priceLabel"
                      [disableOptionCentering]="true"
                      placeholder="Select Up-Charge Reason"
                      [compareWith]="compareFn"
                    >
                      <mat-option
                        *ngFor="let type of priceLevelOptions"
                        [value]="type"
                      >
                        {{ type?.name }}
                      </mat-option>
                    </mat-select>
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        printLabelForm?.get('priceLabel')?.valid ||
                        printLabelForm?.get('priceLabel')?.untouched
                      "
                    >
                      Price Level is required
                    </p>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center mt-2">
                  <div class="col-4">
                    <label for="SalesRepMailId" name="title" class="form-label"
                      ><b>Label Type</b> <span class="stariCON">*</span></label
                    >
                  </div>
                  <div class="col-10">
                    <mat-select
                      [dir]="langDir"
                      class="form-control"
                      formControlName="labelType"
                      [disableOptionCentering]="true"
                      placeholder="Select label type"
                      [compareWith]="compareFn"
                    >
                      <mat-option *ngFor="let type of labelType" [value]="type">
                        {{ type?.name }}
                      </mat-option>
                    </mat-select>
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        printLabelForm?.get('labelType')?.valid ||
                        printLabelForm?.get('labelType')?.untouched
                      "
                    >
                      Label Type is required
                    </p>
                  </div>
                </div>

                <div class="table-responsive mt-3">
                  <table
                    mat-table
                    [dataSource]="dataSource"
                    class="table table-bordered table-hover grid-height"
                  >
                    <ng-container matColumnDef="itemId">
                      <th
                        class="table-column-200"
                        mat-header-cell
                        *matHeaderCellDef
                      >
                        Item Id
                      </th>
                      <td
                        class="table-column-200"
                        mat-cell
                        *matCellDef="let row"
                      >
                        {{ row?.productNumber }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="itemName">
                      <th
                        class="table-column-200"
                        mat-header-cell
                        *matHeaderCellDef
                      >
                        Item Name
                      </th>
                      <td
                        class="table-column-200"
                        mat-cell
                        *matCellDef="let row"
                      >
                        {{ row?.itemName }}
                      </td>
                    </ng-container>

                    <ng-container *ngIf="dataSource?.length <= 0">
                      <tr>
                        <td colspan="2">
                          <span class="p-4 mt-4">
                            <b> {{ "NO_DATA_FOUND" | translate }}</b>
                          </span>
                        </td>
                      </tr>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumns; sticky: true"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                  </table>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="btn-save d-flex justify-content-between col-12">
          <button class="btn btn-danger" (click)="closePrintLabelModal(true)">
            Cancel
          </button>
          <button
            class="btn blue-btn"
            (click)="printLabes()"
            [disabled]="printLabelForm?.invalid"
          >
            <i class="fas fa-print"></i> Print Labels
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
